import React, {useContext} from "react";
import {Avatar, Comment} from "antd";
import MarkdownTimeline from "./MarkdownTimeline";
import {FeatherIcon} from "@web/assets/icons";
import PropTypes from "prop-types";
import UserAvatar from './UserAvatar';

AiChatAnswer.propTypes = {
  agentId: PropTypes.string,
  answerIndex: PropTypes.number.isRequired,
  chatIndex: PropTypes.number,
  text: PropTypes.string,
  widget: PropTypes.object,
  toolCalls: PropTypes.array,
  toolResults: PropTypes.array,
  charts: PropTypes.object,
};

export default function AiChatAnswer(props) {
  if (!props.text) {
    return null;
  }

  return <article className="sub-message" style={{paddingLeft: 20}}>
    <Comment
      author={props.agentId}
      content={!!props.text ? <MarkdownTimeline
        markdown={props.text?.trim()}
        // path={props.path}
        active={false}
      /> : null
      }
      avatar={
      <UserAvatar
        icon={
          <FeatherIcon
            className="gold-icon"
            style={{position: 'relative', top: 0}}
          />
      }
        size="large"
      />}
    />
  </article>
}
